module.exports = __webpack_public_path__ + "img/test.b58372e6.jpg";